export interface EditionMeta {
  format?: string[];
  title?: string[];
  fullTitle?: string[];
  abbrTitle?: string[];
  formerTitle?: string[];
  uniformTitle?: string[];
  alternateTitle?: string[];
  addedTitle?: string[];
  edition?: string[];
  author?: string[];
  vendor?: string[];
  publisherInfo?: string[];
  physicalDescription?: string[];
  electronicNote?: string[];
  frequency?: string[];
  itemLanguage?: string[];
  workLanguage?: string[];
  langIncludesText?: string[];
  langSummary?: string[];
  langSungSpoken?: string[];
  langLibrettos?: string[];
  langTableOfContents?: string[];
  langAccMaterials?: string[];
  langOrigTranslatedFrom?: string[];
  langIntertitles?: string[];
  langSubtitles?: string[];
  langInterTranslation?: string[];
  langOrigAccMaterials?: string[];
  langOrigLibrettos?: string[];
  langCaptions?: string[];
  langAccessibleAudio?: string[];
  langAccessibleVisual?: string[];
  langAccTranscripts?: string[];
  // accessibility
  accessibilityInfo?: string[];
  // series
  seriesTitle?: string[];
  // swissCollections
  swissCollections?: string[];
  // subjects
  subjPersonalName?: string[];
  subjCorporateName?: string[];
  subjMeetingName?: string[];
  subjNamedEvent?: string[];
  subjChronologicalTerm?: string[];
  subjTopicalTerm?: string[];
  subjUncontrolledTerm?: string[];
  subjFacetedTopicTerm?: string[];
  subjGenre?: string[];
  subjOccupation?: string[];
  subjFunction?: string[];
  subjCurriculumObj?: string[];
  subjPlaceName?: string[];
  subjEntityType?: string[];
  subjLocal?: string[];
  // noteGeneral
  noteGeneral?: string[];
  noteWith?: string[];
  noteDissertation?: string[];
  noteBibliography?: string[];
  noteTableOfContents?: string[];
  noteRestrictions?: string[];
  noteScale?: string[];
  noteCredits?: string[];
  noteCitation?: string[];
  noteParticipant?: string[];
  noteReport?: string[];
  noteDataQuality?: string[];
  noteNumbering?: string[];
  noteComputerFileType?: string[];
  noteEvent?: string[];
  noteSummary?: string[];
  noteAudience?: string[];
  noteGeographic?: string[];
  notePrefCitation?: string[];
  noteSupplement?: string[];
  noteStudyProgram?: string[];
  noteAddlForm?: string[];
  noteAccessibility?: string[];
  noteReproduction?: string[];
  noteOriginalVersion?: string[];
  noteLocationOriginals?: string[];
  noteFunding?: string[];
  noteSystemDetails?: string[];
  noteTermsOfUse?: string[];
  noteSourceOfAcq?: string[];
  noteCopyrightStatus?: string[];
  noteLocationOtherMaterials?: string[];
  noteBiographical?: string[];
  noteLanguage?: string[];
  noteFormerTitle?: string[];
  noteIssuingBody?: string[];
  noteEntityInfo?: string[];
  noteCumulativeIndex?: string[];
  noteDocumentationInfo?: string[];
  noteOwnership?: string[];
  noteCopyVersion?: string[];
  noteBinding?: string[];
  noteCaseFile?: string[];
  noteMethodology?: string[];
  noteLinkingEntry?: string[];
  notePublications?: string[];
  noteAction?: string[];
  noteAccumulation?: string[];
  noteExhibitions?: string[];
  noteAwards?: string[];
  noteSourceOfDesc?: string[];
  noteLocal?: string[];
  // controlNumbers
  isbn?: string[];
  issn?: string[];
  upc?: string[];
  publisherNumber?: string[];
  bibId?: string[];
}

export interface EditionMetaData {
  rapido: boolean;
  source: string;
  edition: EditionMeta
  marcRecord?: any
}

export enum EditionSourceType {
  MARC = 'MARC',
  INSTANCE_FALLBACK = 'INSTANCE_FALLBACK'
}
